import { Injectable, inject } from '@angular/core';
import { LocalStorageService } from '@app/auth/local-storage.service';
import { ProjectsViewService } from '@app/cem/project/services/projects-view.service';
import { IProjectTabArgs } from '@app/shared/models/project/iproject-tab-args';
import { ProjectsView } from '@app/shared/models/projects-view';
import { Project } from 'app/shared/models';
import { ProjectTab } from 'app/shared/models/project/Project-Tab';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectTabService {
  private localStorage = inject(LocalStorageService);
  private projectsViewService = inject(ProjectsViewService);

  private userSettings: string = 'UserSettings';

  private projectTabSource = new Subject<IProjectTabArgs>();

  private projectsSource = new Subject<ProjectTab[]>();

  public projectTab$ = this.projectTabSource.asObservable();

  public projectTabs$ = this.projectsSource.asObservable();

  public projectTab(tab: ProjectTab, activate: boolean) {
    let args: IProjectTabArgs = {
      ProjectTab: tab,
      Activate: activate
    };

    this.projectTabSource.next(args);
  }

  public projectTabs(tabs: ProjectTab[]) {
    this.projectsSource.next(tabs);
  }

  public open(dataItem: ProjectsView, activate: boolean, reprocess: boolean) {
    let proj = this.projectsViewService.convertToProject(dataItem);

    if (!reprocess) {
      this.saveLocalStorage(proj);
    }

    let assetTeamId = proj.AssetTeam && proj.AssetTeam.AssetTeamId;
    let defaultProjectTeamId = proj.DefaultProjectTeamId;
    let functionId = proj.FunctionId;
    let scenarioId = proj.ScenarioId;
    let isProjectTeamSync = proj.IsProjectTeamSync;
    let projectStatusId = proj.ProjectStatus && proj.ProjectStatus.ProjectStatusId;
    let projectTypeDescription = proj.ProjectType && proj.ProjectType.Description;
    let projectTypeId = proj.ProjectTypeId;
    let projectName = proj.Name;
    let projectId = proj.ProjectId;
    let afeNumber = proj.AfeNumber;

    let projectTab: ProjectTab = new ProjectTab({
      ProjectId: projectId,
      AfeNumber: afeNumber,
      Name: projectName,
      ProjectTypeId: projectTypeId,
      ProjectType: projectTypeDescription,
      AssetTeamId: assetTeamId,
      ScenarioId: scenarioId,
      DefaultProjectTeamId: defaultProjectTeamId,
      FunctionId: functionId,
      IsProjectTeamSync: isProjectTeamSync,
      ProjectStatusId: projectStatusId,
      IsSelected: true,
      Disabled: false,
      Project: proj
    });

    this.projectTab(projectTab, activate);
  }

  public remove(id: any, tabItems: ProjectTab[]) {
    let y: any = tabItems.findIndex(z => z.ProjectId === id);
    tabItems.splice(y, 1);
    this.removeFromStorage(id);
    this.projectTabs(tabItems);
  }

  public removeAll(tabItems: ProjectTab[]) {
    tabItems.forEach(item => {
      this.removeFromStorage(item.ProjectId);
    });

    tabItems.splice(0, tabItems.length);

    this.projectTabs(tabItems);
  }

  public removeAllOthers(id: any, tabItems: ProjectTab[]) {
    let index: any = tabItems.findIndex(z => z.ProjectId === id);

    tabItems.forEach(item => {
      if (item.ProjectId != id) {
        this.removeFromStorage(item.ProjectId);
      }
    });

    for (let i = tabItems.length - 1; i >= 0; i--) {
      if (i !== index) {
        tabItems.splice(i, 1);
      }
    }

    this.projectTabs(tabItems);
  }

  public processTabs(tabstrip: any) {
    const self = this;

    if (this.get()) {

      this.get().forEach((element) => {
        self.open(element, false, true);
      });
    }
  }

  private get() {
    const storedData = JSON.parse(localStorage.getItem(this.userSettings));

    if (storedData && storedData.projects) {
      return storedData.projects;
    }
    return [];
  }

  private removeFromStorage(id: any) {
    const tabs = this.get();

    let y: any = tabs.findIndex(z => z.ProjectId === id);
    tabs.splice(y, 1);

    let data = {
      projects: tabs
    };
    this.localStorage.setItem(this.userSettings, data);
  }

  private saveLocalStorage(tabItem: Project) {
    const settings = localStorage.getItem(this.userSettings);

    let data = {
      projects: null
    };

    if (settings) {
      data = JSON.parse(settings);
    }

    if (data.projects) {
      let existingIndex = data.projects.findIndex(f => f.ProjectId === tabItem.ProjectId);

      if (existingIndex === -1) {
        data.projects.push(tabItem);
      }
    } else {
      let settingsArray = [];
      settingsArray.push(tabItem);
      data.projects = settingsArray;
    }

    this.localStorage.setItem(this.userSettings, data);
  }
}